import { render, staticRenderFns } from "./Mods.vue?vue&type=template&id=55cc1d1e&"
import script from "./Mods.vue?vue&type=script&lang=js&"
export * from "./Mods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports